import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@mui/material";
import { Add, Edit, Delete, Close, Download } from "@mui/icons-material";
import "./Asignstructure.css";

const emptyRow = {
  empId: "",
  employeeName: "",
  location: "",
  designation: "",
  rulesApplied: "",
  ctc: "",
  basic: "",
  foodCoupons: "",
  hra: "",
  medical: "",
  internet: "",
  telephone: "",
  lta: "",
  newspaper: "",
  groupInsurance: "",
  phoneReimbursement: "",
  conveyance: "",
  pfEmployer: "",
  specialAllowance: "",
};

const SalaryStructureAssign = () => {
  const [fileName, setFileName] = useState("");
  const [rows, setRows] = useState([
    {
      empId: "EMP001",
      employeeName: "Amit Sharma",
      location: "Bangalore",
      designation: "Software Engineer",
      rulesApplied: "Structure A",
      ctc: "12,00,000",
      basic: "4,00,000",
      foodCoupons: "22,000",
      hra: "2,00,000",
      medical: "15,000",
      internet: "12,000",
      telephone: "8,000",
      lta: "30,000",
      newspaper: "2,000",
      groupInsurance: "18,000",
      phoneReimbursement: "10,000",
      conveyance: "19,200",
      pfEmployer: "48,000",
      specialAllowance: "1,70,800",
    },
    {
      empId: "EMP002",
      employeeName: "Neha Verma",
      location: "Hyderabad",
      designation: "Finance Analyst",
      rulesApplied: "Structure B",
      ctc: "9,50,000",
      basic: "3,50,000",
      foodCoupons: "18,000",
      hra: "1,75,000",
      medical: "15,000",
      internet: "10,000",
      telephone: "6,000",
      lta: "25,000",
      newspaper: "1,500",
      groupInsurance: "16,000",
      phoneReimbursement: "9,000",
      conveyance: "19,200",
      pfEmployer: "42,000",
      specialAllowance: "1,40,300",
    },
  ]);
  const [form, setForm] = useState(emptyRow);
  const [open, setOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const openModal = (row = null, index = null) => {
    setForm(row || emptyRow);
    setEditIndex(index);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setForm(emptyRow);
    setEditIndex(null);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (!fileName) {
      alert("Please enter Salary File Name");
      return;
    }

    if (editIndex !== null) {
      const updated = [...rows];
      updated[editIndex] = form;
      setRows(updated);
    } else {
      setRows([...rows, form]);
    }
    closeModal();
  };

  const handleDelete = (index) => {
    if (window.confirm("Delete this record?")) {
      setRows(rows.filter((_, i) => i !== index));
    }
  };

  const exportCSV = () => {
    const header = Object.keys(emptyRow).join(",");
    const body = rows.map((r) => Object.values(r).join(",")).join("\n");
    const csv = `${header}\n${body}`;
    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName || "salary_structure"}.csv`;
    link.click();
  };

  return (
    <div className="ssa-wrapper">
      <div className="ssa-card">
        {/* HEADER */}
        <div className="ssa-header">
          <h2>Salary Structure Assignment</h2>
        </div>

        {/* FILE NAME + BUTTONS */}
        <div className="ssa-filename">
          <TextField
            label="Salary File Name"
            size="small"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
          />
          <Box className="ssa-buttons-right">
            <Button
              className="ssa-add-btn"
              startIcon={<Add />}
              onClick={() => openModal()}
            >
              Add Employee
            </Button>
            <Button
              className="ssa-export-btn"
              startIcon={<Download />}
              onClick={exportCSV}
            >
              Export
            </Button>
          </Box>
        </div>

        {/* TABLE */}
        <TableContainer component={Paper} className="ssa-table">
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Employee Name</TableCell>
                <TableCell>Designation</TableCell>
                <TableCell>CTC</TableCell>
                <TableCell>Basic</TableCell>
                <TableCell>HRA</TableCell>
                <TableCell>Special Allowance</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.empId}</TableCell>
                  <TableCell>{row.employeeName}</TableCell>
                  <TableCell>{row.designation}</TableCell>
                  <TableCell>{row.ctc}</TableCell>
                  <TableCell>{row.basic}</TableCell>
                  <TableCell>{row.hra}</TableCell>
                  <TableCell>{row.specialAllowance}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="warning"
                      onClick={() => openModal(row, index)}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(index)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {!rows.length && (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No salary structure assigned
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* MODAL */}
      <Modal open={open} onClose={closeModal}>
        <Box className="ssa-modal">
          <div className="ssa-modal-header">
            <h3>Employee Salary Details</h3>
            <IconButton onClick={closeModal}>
              <Close />
            </IconButton>
          </div>

          <div className="ssa-modal-grid">
            {Object.keys(emptyRow).map((key) => (
              <TextField
                key={key}
                label={key.replace(/([A-Z])/g, " $1")}
                name={key}
                size="small"
                value={form[key]}
                onChange={handleChange}
              />
            ))}
          </div>

          <div className="ssa-modal-actions">
            <Button onClick={closeModal} color="inherit">
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSave}>
              Save
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default SalaryStructureAssign;
